var render = function render() {
  var _vm$memberProfile, _vm$form, _vm$memberProfile2, _vm$memberProfile3, _vm$memberProfile4;
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('main', {
    class: [{
      loaded: _vm.loaded
    }, '-mt-10 sm-md:mt-0' /*, 'pt-32 sm-md:pt-20'*/],
    attrs: {
      "data-cy": _vm.purchaseClass,
      "data-state": _vm.currentStage
    }
  }, [_vm.currentStage == 'form' ? _c('img', {
    staticStyle: {
      "border-style": "none"
    },
    attrs: {
      "height": "1",
      "width": "0",
      "alt": "",
      "src": _vm.ttdUrl
    }
  }) : _vm._e(), _vm._v(" "), _c('loading-overlay', {
    attrs: {
      "wait-for": _vm.showLoadingOverlay,
      "reason": _vm.processingReason,
      "sub-reason": _vm.finishing ? 'This usually takes 25 seconds...' : undefined,
      "fill-color": _vm.finishing ? '#36FAA5' : undefined,
      "progress-bar-time": _vm.finishing ? 25000 : undefined,
      "tracking": {
        class: 'members-area-card',
        subclass: 'page'
      }
    },
    model: {
      value: _vm.loaded,
      callback: function ($$v) {
        _vm.loaded = $$v;
      },
      expression: "loaded"
    }
  }), _vm._v(" "), !_vm.processing ? _c('transition', {
    attrs: {
      "name": "slide-fade",
      "mode": "out-in"
    }
  }, [_vm.currentStage === _vm._STAGE_enum.error ? _c('funnel-error', {
    key: _vm._STAGE_enum.error,
    staticClass: "dash--section",
    attrs: {
      "error-context": _vm.errorContext,
      "can-retry-plaid": _vm.canRetryPlaid,
      "is-dev": _vm.isDev
    },
    on: {
      "reset-plaid": _vm.resetPlaid,
      "clear-error": _vm.clearError
    }
  }) : _vm._e(), _vm._v(" "), _vm.currentStage === _vm._STAGE_enum.warning ? _c('funnel-warning', {
    key: _vm._STAGE_enum.warning,
    staticClass: "dash--section",
    attrs: {
      "warning-context": _vm.warningContext,
      "plan-price": _vm.upfrontPrice,
      "can-retry-plaid": _vm.canRetryPlaid,
      "is-dev": _vm.isDev
    },
    on: {
      "form-fill-retry": _vm.formFillRetry,
      "retry-plaid": _vm.promptPlaidRelink,
      "change-plan": _vm.insufficientBillingBack,
      "clear-error": _vm.clearError
    }
  }) : _vm._e(), _vm._v(" "), _vm.currentStage === _vm._STAGE_enum.locked && _vm.lock ? _c('section', {
    key: _vm._STAGE_enum.locked,
    staticClass: "dash--section"
  }, [_c('div', {
    staticClass: "section--container"
  }, [_c('div', {
    staticClass: "container max-w-3xl -mt-2 section--content"
  }, [_c('img', {
    staticClass: "w-8 mb-6",
    attrs: {
      "src": require("assets/images/lock.svg")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "font-medium tracking-widest uppercase opacity-50 text-md"
  }, [_vm._v("\n\t\t\t\t\t\t\tYour Extra Account is locked\n\t\t\t\t\t\t")]), _vm._v(" "), _c('h2', {
    staticClass: "my-5 mb-8"
  }, [_vm._v(_vm._s(_vm.lock.title))]), _vm._v(" "), _vm.lock.subtitle ? _c('p', {
    staticClass: "my-6 text-xl font-medium leading-9"
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.lock.subtitle) + "\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('p', {
    directives: [{
      name: "sani-html",
      rawName: "v-sani-html",
      value: _vm.lock.body,
      expression: "lock.body"
    }],
    staticClass: "my-8 text-lg leading-8"
  }), _vm._v(" "), _c('p', {
    staticClass: "py-1 pl-4 my-12 tracking-wide border-l-2 border-white opacity-100 text-md font-base"
  }, [_vm._v("\n\t\t\t\t\t\t\tOpen your "), _c('img', {
    staticClass: "inline w-6 h-6",
    attrs: {
      "src": require("assets/images/extra-finsta.png")
    }
  }), _vm._v(" Extra\n\t\t\t\t\t\t\tapp for further details and actions. Tap to download.\n\t\t\t\t\t\t")]), _vm._v(" "), _c('disclosure-footer')], 1)])]) : _vm.decisionFinalRejected && _vm.canRetryPlaid ? _c('section', {
    key: 'decision-retry',
    staticClass: "dash--section"
  }, [_c('div', {
    staticClass: "section--container"
  }, [_c('div', {
    staticClass: "container max-w-3xl section--content"
  }, [_c('img', {
    staticClass: "block w-12 mb-8",
    attrs: {
      "src": require("assets/images/section_bank.svg")
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Unfortunately, we aren’t a good fit for the bank account that you connected.")]), _vm._v(" "), _c('p', {
    staticClass: "my-8 text-xl leading-8"
  }, [_vm._v("Would you like to try a different one?")]), _vm._v(" "), _c('button', {
    staticClass: "my-4",
    on: {
      "click": _vm.resetPlaid
    }
  }, [_vm._v("Yes, I’ll try another account.")]), _vm._v(" "), _c('button', {
    staticClass: "my-4",
    on: {
      "click": function ($event) {
        _vm.canRetryPlaid = false;
      }
    }
  }, [_vm._v("No, that’s my main account.")])]), _vm._v(" "), _c('disclosure-footer')], 1)]) : _vm.decisionFinalRejected && !_vm.canRetryPlaid ? _c('section', {
    key: 'decision',
    staticClass: "dash--section"
  }, [_c('div', {
    staticClass: "section--container"
  }, [_c('div', {
    staticClass: "container max-w-3xl section--content"
  }, [!_vm.partialData ? _c('div', [_c('h2', {
    staticClass: "my-6"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tUnfortunately, we cannot offer you the Extra Debit Card at this time.\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "my-8 text-xl leading-8"
  }, [_vm._v("Thank you for your time and interest in Extra.")]), _vm._v(" "), _c('p', {
    staticClass: "my-8 text-lg italic leading-8 opacity-75"
  }, [_vm._v("You will not be billed")]), _vm._v(" "), _vm.promptManualReview ? _c('div', [_c('p', {
    staticClass: "my-8 italic"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tThink this is a mistake? Feel free to request an additional review. Contact Member\n\t\t\t\t\t\t\t\t\tConcierge at "), _c('a', {
    attrs: {
      "href": "mailto:hey@extra.app"
    }
  }, [_vm._v("hey@extra.app")]), _vm._v(".\n\t\t\t\t\t\t\t\t")])]) : _vm._e()]) : _c('div', [_c('h2', {
    staticClass: "my-6"
  }, [_c('img', {
    staticClass: "w-12 mb-8",
    attrs: {
      "src": require("assets/images/section_bank.svg")
    }
  }), _vm._v("\n\t\t\t\t\t\t\t\tWe don't see any transaction history for the bank account that you have connected.\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "my-8 text-xl leading-8"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tIf this is a new account, or if you think there was a mistake, please reach out to\n\t\t\t\t\t\t\t\tMember Concierge for help at "), _c('a', {
    attrs: {
      "href": "mailto:hey@extra.app"
    }
  }, [_vm._v("hey@extra.app")]), _vm._v(".\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('disclosure-footer')], 1)])]) : _vm.currentStage === _vm._STAGE_enum.policyUpdate ? _c('policy-update-section', {
    key: _vm._STAGE_enum.policyUpdate,
    attrs: {
      "policy-metadata": _vm.confirmationPolicyMetadata,
      "plan": _vm.plan,
      "plan-autopay": _vm.planAutopay,
      "extra-user": _vm.memberProfile && Boolean(_vm.memberProfile.billing_confirmed),
      "application-queued": _vm.memberProfile && Boolean(_vm.memberProfile.application_queued),
      "mid": _vm.memberProfile.id
    },
    on: {
      "disclosure": disc => _vm.showThisDisclosure(disc),
      "error": error => _vm.onSectionError(_vm._STAGE_enum.policyUpdate, error),
      "complete": _vm.onPolicyUpdateComplete
    }
  }) : _vm.currentStage === _vm._STAGE_enum.creditGoals ? _c('section', {
    key: _vm._STAGE_enum.creditGoals
  }, [_c('div', {
    staticClass: "section--container"
  }, [_c('member-survey', {
    attrs: {
      "initial-question-ids": _vm.memberProfile.credit_goals_pending_questions,
      "credit-band-variant": _vm.creditBandVariant,
      "credit-band-question": _vm.creditBandVariant === 2 && !_vm.creditBandAnswered,
      "member-profile": _vm.memberProfile
    },
    on: {
      "showDisclosure": _vm.showThisDisclosure,
      "complete": _vm.memberSurveyCompleteHandler
    }
  })], 1)]) : _vm.currentStage === _vm._STAGE_enum.plan ? _c('plan-section', {
    key: "plan",
    attrs: {
      "plans": _vm.plans,
      "plan": _vm.plan,
      "continue-button-action": _vm.submitPlan,
      "member-profile": _vm.memberProfile
    },
    on: {
      "update:plan": function ($event) {
        _vm.plan = $event;
      }
    }
  }) : _vm.currentStage === _vm._STAGE_enum.plaid ? _c('section', {
    key: _vm._STAGE_enum.plaid,
    staticClass: "plaid--section"
  }, [_vm.plaidSectionLayout === 1 || _vm.plaidSectionLayout === 2 || _vm.plaidSectionLayout === 3 ? _c('plaid-section', {
    attrs: {
      "layout": _vm.plaidSectionLayout,
      "plaid-processing": _vm.plaidProcessing
    },
    on: {
      "continue": _vm.openPlaid
    }
  }) : _c('div', {
    staticClass: "section--container"
  }, [_c('div', {
    staticClass: "container max-w-2xl section--content sm-md:flex sm-md:flex-col"
  }, [_c('progress-indicator', {
    staticClass: "sm-md:mt-4 -mb-8",
    attrs: {
      "step": 3
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "flex flex-col items-center"
  }, [_c('img', {
    staticClass: "w-48",
    attrs: {
      "src": require("assets/images/extra-link-icon.svg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "self-start"
  }, [_vm._v("Time to connect your bank.")])]), _vm._v(" "), _c('p', {
    staticClass: "mt-6 mb-8 text-xl leading-6 sm-md:text-lg"
  }, [_vm._v("\n\t\t\t\t\t\t\tExtra uses Plaid to securely connect to your bank account, allowing us to transfer\n\t\t\t\t\t\t\tfunds (ACH's) when you likely have enough money.\n\t\t\t\t\t\t")]), _vm._v(" "), _c('h2', [_vm._v("This connection allows Extra to:")]), _vm._v(" "), _c('ul', {
    staticClass: "mb-8 text-xl leading-6 sm-md:text-lg"
  }, [_c('li', {
    staticClass: "flex mb-3"
  }, [_c('div', {
    staticClass: "mr-5"
  }, [_vm._v("🔐")]), _vm._v("\n\t\t\t\t\t\t\t\tKeep your information safe\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('li', {
    staticClass: "flex mb-3"
  }, [_c('div', {
    staticClass: "mr-5"
  }, [_vm._v("🤑")]), _vm._v("\n\t\t\t\t\t\t\t\tCalculate how much you can spend with your card*\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('li', {
    staticClass: "flex mb-3"
  }, [_c('div', {
    staticClass: "mr-5"
  }, [_vm._v("🛍️")]), _vm._v("\n\t\t\t\t\t\t\t\tUse your bank account to cover your Extra Debit Card purchases\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('li', {
    staticClass: "flex mb-3"
  }, [_c('div', {
    staticClass: "mr-5"
  }, [_vm._v("💪")]), _vm._v("\n\t\t\t\t\t\t\t\tPower up your bank account by providing features such as credit reporting and reward\n\t\t\t\t\t\t\t\tpoints\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('button', {
    staticClass: "button--filled sm-md:w-full",
    class: {
      disabled: _vm.plaidProcessing
    },
    attrs: {
      "disabled": _vm.plaidProcessing,
      "data-cy": "open-plaid"
    },
    on: {
      "click": _vm.openPlaid
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.plaidProcessing ? 'Hold tight...' : 'Continue') + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "mt-8 text-sm color--dark--grey"
  }, [_vm._v("\n\t\t\t\t\t\t\tYour available Spend Power is the amount you can spend on your Extra Card at any given\n\t\t\t\t\t\t\ttime. It utilizes your live bank balance and is affected by in-flight purchases. If\n\t\t\t\t\t\t\tyour bank balance is at or below your Max Spend Power, your available Spend Power may\n\t\t\t\t\t\t\tdecrease. Loans provided by Lead Bank.\n\t\t\t\t\t\t")])], 1)]), _vm._v(" "), _vm.plaidEnv === 'sandbox' ? _c('div', {
    staticClass: "flex justify-center"
  }, [!_vm.showPlaidTestCredentials ? _c('button', {
    staticClass: "button--white w-auto mt-5 text-sm",
    on: {
      "click": function ($event) {
        _vm.showPlaidTestCredentials = true;
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tshow test credentials (sandbox)\n\t\t\t\t\t")]) : _vm.showPlaidTestCredentials ? _c('pre', {
    staticClass: "my-10 opacity-75 text-md"
  }, [_vm._v(_vm._s(`sandbox test accounts:

rejected:	 user_good
approved:	 custom_approved
no history:	 custom_empty
$23 balance: custom_approved_23
$15 balance: custom_approved_15

pw is always: pass_good`))]) : _vm._e()]) : _vm._e()], 1) : _vm.currentStage === _vm._STAGE_enum.form ? _c('section', {
    key: _vm._STAGE_enum.form,
    staticClass: "details--section"
  }, [_vm.addressErrorMessage.length ? _c('AddressErrorModal', {
    attrs: {
      "message": _vm.addressErrorMessage
    },
    on: {
      "confirm": _vm.clearAddressModal
    }
  }) : _vm._e(), _vm._v(" "), _vm.addressSuggestions.length ? _c('AddressSuggestionModal', {
    attrs: {
      "suggestion": _vm.addressSuggestions,
      "original-address": _vm.form.address
    },
    on: {
      "selected": _vm.addressCorrectionSelected
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section--container"
  }, [_c('div', {
    staticClass: "container max-w-3xl section--content"
  }, [_c('progress-indicator', {
    staticClass: "-mt-4 mb-8",
    attrs: {
      "step": 4
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "mb-12 sm-md:mb-4"
  }, [_vm._v("Let’s verify your info.")]), _vm._v(" "), _vm.promptECBSV && _vm.growthbookDynamicValues.funnel_ecbsv_modal && _vm.growthbookDynamicValues.funnel_use_finish_controller ? _c('ECBSVModal', {
    attrs: {
      "show": _vm.promptECBSV === true,
      "member-id": (_vm$memberProfile = _vm.memberProfile) === null || _vm$memberProfile === void 0 ? void 0 : _vm$memberProfile.id,
      "local-form-policies": _vm.formPolicies
    },
    on: {
      "checkbox-changed": _vm.handleECBSVAgreed
    }
  }) : _vm._e(), _vm._v(" "), _c('form', {
    on: {
      "submit": _vm.addressAuthVerify
    }
  }, [_c('h4', {
    staticClass: "mb-4"
  }, [_vm._v("Personal Information")]), _vm._v(" "), _c('form-personal-info', {
    attrs: {
      "form": _vm.form,
      "form-errors": _vm.formErrors,
      "show-email-tooltip": _vm.formShowEmailTooltip
    },
    on: {
      "update:form": function ($event) {
        _vm.form = $event;
      },
      "update:showEmailTooltip": function ($event) {
        _vm.formShowEmailTooltip = $event;
      },
      "update:show-email-tooltip": function ($event) {
        _vm.formShowEmailTooltip = $event;
      },
      "onFieldFocus": function ($event) {
        return _vm.onFieldFocus($event);
      },
      "onFieldBlur": function ($event) {
        return _vm.onFieldBlur($event);
      },
      "onFieldChange": function ($event) {
        return _vm.onFieldChange($event);
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col"
  }, [_c('div', {
    staticClass: "flex flex-col items-start"
  }, [_c('div', {
    staticClass: "flex flex-row items-baseline"
  }, [_c('h4', [_vm._v("Home Address")]), _vm._v(" "), _c('p', {
    staticClass: "mb-2 ml-2 opacity-50 sm-md:hidden"
  }, [_vm._v("(where we ship your card)")])]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 italic opacity-25"
  }, [_vm._v("P.O. Boxes will not be accepted")])]), _vm._v(" "), _c('AddressDropdown', {
    attrs: {
      "autocomplete-result": _vm.autocompleteResult,
      "input-class": _vm.formErrors.address_street_one && 'invalid',
      "no-shake": true
    },
    on: {
      "update:autocompleteResult": function ($event) {
        _vm.autocompleteResult = $event;
      },
      "update:autocomplete-result": function ($event) {
        _vm.autocompleteResult = $event;
      },
      "input": _vm.onAutoCompleteInput,
      "selectAddressHandler": _vm.onSelectAddressHandler,
      "focus": () => _vm.onFieldFocus('street_one'),
      "blur": () => _vm.onFieldBlur('address_street_one'),
      "keyup": () => _vm.onFieldChange('address_street_one')
    },
    model: {
      value: _vm.form.address.street_one,
      callback: function ($$v) {
        _vm.$set(_vm.form.address, "street_one", $$v);
      },
      expression: "form.address.street_one"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.address.street_two,
      expression: "form.address.street_two"
    }],
    class: _vm.formErrors.address_street_two && 'invalid',
    attrs: {
      "placeholder": "Address 2",
      "type": "street2",
      "name": "street_two",
      "autocomplete": "address-line2"
    },
    domProps: {
      "value": _vm.form.address.street_two
    },
    on: {
      "focus": () => _vm.onFieldFocus('street_two'),
      "blur": () => _vm.onFieldBlur('address_street_two'),
      "keyup": () => _vm.onFieldChange('address_street_two'),
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form.address, "street_two", $event.target.value);
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex space-x-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.address.city,
      expression: "form.address.city"
    }],
    staticClass: "w-3/6",
    class: _vm.formErrors.address_city && 'invalid',
    attrs: {
      "placeholder": "City",
      "type": "city",
      "name": "city",
      "autocomplete": "address-level2",
      "required": ""
    },
    domProps: {
      "value": _vm.form.address.city
    },
    on: {
      "focus": () => _vm.onFieldFocus('city'),
      "blur": () => _vm.onFieldBlur('address_city'),
      "keyup": () => _vm.onFieldChange('address_city'),
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form.address, "city", $event.target.value);
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.address.state,
      expression: "form.address.state"
    }],
    staticClass: "w-2/6",
    class: _vm.formErrors.address_state && 'invalid',
    attrs: {
      "placeholder": "State",
      "type": "state",
      "name": "state",
      "autocomplete": "address-level1",
      "required": ""
    },
    on: {
      "focus": () => _vm.onFieldFocus('state'),
      "blur": () => _vm.onFieldBlur('address_state'),
      "keyup": () => _vm.onFieldChange('address_state'),
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.form.address, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("State")]), _vm._v(" "), _vm._l(_vm.states, function (state) {
    return _c('option', {
      key: state,
      domProps: {
        "value": state
      }
    }, [_vm._v(_vm._s(state))]);
  })], 2), _vm._v(" "), _c('the-mask', {
    staticClass: "w-3/6",
    class: _vm.formErrors.address_zip_code && 'invalid',
    attrs: {
      "mask": "#####",
      "placeholder": "Zip Code",
      "type": "zip",
      "name": "zip_code",
      "pattern": "[0-9]*",
      "maxlength": "5",
      "required": "",
      "autocomplete": "postal-code"
    },
    nativeOn: {
      "focus": function ($event) {
        return (() => _vm.onFieldFocus('zip_code')).apply(null, arguments);
      },
      "blur": function ($event) {
        return (() => _vm.onFieldBlur('address_zip_code')).apply(null, arguments);
      },
      "keyup": function ($event) {
        return (() => _vm.onFieldChange('address_zip_code')).apply(null, arguments);
      }
    },
    model: {
      value: _vm.form.address.zip_code,
      callback: function ($$v) {
        _vm.$set(_vm.form.address, "zip_code", $$v);
      },
      expression: "form.address.zip_code"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "-mx-6",
    class: _vm.ecbsvInvalid ? 'py-5 my-2 card warn-card px-8' : 'px-6',
    attrs: {
      "id": "ecbsv-scroll"
    }
  }, [_c('div', {
    staticClass: "flex mt-2 align-center sm-md:flex-col",
    class: !_vm.ecbsvInvalid && 'hidden'
  }, [_c('img', {
    staticClass: "w-8 mr-5 sm-md:w-6 sm-md:mb-3",
    attrs: {
      "src": require("assets/images/warn_orange.svg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-grow"
  }, [_c('p', {
    staticClass: "mb-1 text-xl font-semibold leading-6"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tAre these details correct?"), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "text-base leading-6 opacity-100"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tWe couldn’t verify your info with the Social Security Administration. Please\n\t\t\t\t\t\t\t\t\t\t\tdouble check to ensure you’ve entered your credentials correctly.\n\t\t\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex space-x-5 sm-md:flex-col sm-md:space-x-0"
  }, [_c('div', {
    staticClass: "flex-grow w-1/2 sm-md:w-full"
  }, [_c('div', {
    staticClass: "flex flex-row items-baseline"
  }, [_c('h4', [_vm._v("SSN / ITIN")]), _vm._v(" "), _c('p', {
    staticClass: "mb-2 ml-2 whitespace-nowrap opacity-50"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t(to make sure it's actually you)\n\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col"
  }, [_c('the-mask', {
    class: _vm.formErrors.ssn && 'invalid',
    attrs: {
      "mask": '###-##-####',
      "masked": false,
      "type": "text",
      "autocomplete": "off",
      "name": "ssn",
      "placeholder": "000-00-0000",
      "pattern": "\\d{3}-\\d{2}-\\d{4}",
      "maxlength": "11",
      "required": "",
      "autofocus": !!_vm.memberProfile.shopify_completed && 'autofocus'
    },
    nativeOn: {
      "focus": function ($event) {
        return (() => _vm.onFieldFocus('ssn')).apply(null, arguments);
      },
      "blur": function ($event) {
        return (() => _vm.onFieldBlur('ssn')).apply(null, arguments);
      },
      "keyup": function ($event) {
        return (() => _vm.onFieldChange('ssn', 'date_of_birth')).apply(null, arguments);
      }
    },
    model: {
      value: _vm.form.ssn,
      callback: function ($$v) {
        _vm.$set(_vm.form, "ssn", $$v);
      },
      expression: "form.ssn"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex-grow w-1/2 sm-md:w-full"
  }, [_c('h4', [_vm._v("Date of Birth")]), _vm._v(" "), _vm.isDateSupported ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.date_of_birth,
      expression: "form.date_of_birth"
    }],
    class: _vm.formErrors.date_of_birth && 'invalid',
    attrs: {
      "type": "date",
      "name": "date_of_birth",
      "pattern": "\\d{4}/\\d{2}/\\d{2}",
      "autocomplete": "bday",
      "placeholder": "YYYY-MM-DD",
      "required": ""
    },
    domProps: {
      "value": _vm.form.date_of_birth
    },
    on: {
      "focus": () => _vm.onFieldFocus('date_of_birth'),
      "blur": () => _vm.onFieldBlur('date_of_birth'),
      "keyup": () => _vm.onFieldChange('date_of_birth', 'ssn'),
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "date_of_birth", $event.target.value);
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.date_of_birth,
      expression: "form.date_of_birth"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: '##/##/####',
      expression: "'##/##/####'"
    }],
    class: _vm.formErrors.date_of_birth && 'invalid',
    attrs: {
      "type": "text",
      "name": "date_of_birth",
      "pattern": "\\d{2}/\\d{2}/\\d{4}",
      "autocomplete": "bday",
      "placeholder": "MM/DD/YYYY",
      "required": ""
    },
    domProps: {
      "value": _vm.form.date_of_birth
    },
    on: {
      "focus": () => _vm.onFieldFocus('date_of_birth'),
      "blur": () => _vm.onFieldBlur('date_of_birth'),
      "keyup": () => _vm.onFieldChange('date_of_birth', 'ssn'),
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "date_of_birth", $event.target.value);
      }
    }
  })])])]), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "mb-4"
  }, [_vm._v("Membership Plan")]), _vm._v(" "), _c('form-plan-info', {
    attrs: {
      "selected-plan": _vm.selectedPlan,
      "disable-change-plan": _vm.finishing,
      "billing-cycle": _vm.plan.billingCycle,
      "allow-autopay-change": _vm.allowAutopayChange,
      "autopay": _vm.planAutopay,
      "account-last-four": _vm.accountLastFour,
      "process-date": _vm.achPolicyMetadata.raw_process_date
    },
    on: {
      "update:autopay": function ($event) {
        _vm.planAutopay = $event;
      },
      "changePlan": function ($event) {
        _vm.formShowPlanChangeModal = true;
      }
    }
  }), _vm._v(" "), _c('plan-change-modal', {
    attrs: {
      "open": _vm.formShowPlanChangeModal,
      "plans": _vm.plans,
      "plan": _vm.plan,
      "check-insufficient-funds": _vm.formPlanChangeInsufficientCheck,
      "balance-check": _vm.plaidInsufficient
    },
    on: {
      "update:open": function ($event) {
        _vm.formShowPlanChangeModal = $event;
      },
      "update:plan": function ($event) {
        _vm.plan = $event;
      },
      "update:balanceCheck": function ($event) {
        _vm.plaidInsufficient = $event;
      },
      "update:balance-check": function ($event) {
        _vm.plaidInsufficient = $event;
      },
      "relinkPlaid": _vm.promptPlaidRelink
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "my-8 space-y-5 policies"
  }, [_c('div', {
    staticClass: "space-y-5 color--dark--grey text-lg"
  }, [_c('div', {
    staticClass: "space-y-5"
  }, [_c('div', {
    staticClass: "flex flex-row items-center space-x-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formPolicies,
      expression: "formPolicies"
    }],
    attrs: {
      "id": "extra_credit_notice-input",
      "value": "extra_credit_notice",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.formPolicies) ? _vm._i(_vm.formPolicies, "extra_credit_notice") > -1 : _vm.formPolicies
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.formPolicies,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = "extra_credit_notice",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.formPolicies = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.formPolicies = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.formPolicies = $$c;
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "extra_credit_notice-input"
    }
  }, [_vm._v("I agree to the following:")])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row items-start space-x-3 ml-10"
  }, [_c('span', {
    staticClass: "h-16 sm-md:w-48 check-img",
    class: {
      checked: _vm.formPolicyConsentTimestamps.extra_credit_notice
    },
    attrs: {
      "role": "presentation"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "leading-5"
  }, [_c('a', {
    attrs: {
      "target": "blank"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.showThisDisclosure('FCRA_Notice');
      }
    }
  }, [_vm._v("FCRA Notice")])])]), _vm._v(" "), !_vm.usePatriot ? _c('div', {
    staticClass: "flex flex-row items-start space-x-3 ml-10"
  }, [_c('span', {
    staticClass: "h-16 sm-md:w-48 check-img",
    class: {
      checked: _vm.formPolicyConsentTimestamps.extra_credit_notice
    },
    attrs: {
      "role": "presentation"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "leading-5"
  }, [_c('a', {
    attrs: {
      "target": "blank"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.showThisDisclosure('Cardholder_Agreement');
      }
    }
  }, [_vm._v("Evolve Bank's Debit Cardholder Agreement")])])]) : _c('div', {
    staticClass: "flex flex-row items-start space-x-3 ml-10"
  }, [_c('span', {
    staticClass: "h-16 sm-md:w-48 check-img",
    class: {
      checked: _vm.formPolicyConsentTimestamps.extra_credit_notice
    },
    attrs: {
      "role": "presentation"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "leading-5"
  }, [_c('a', {
    attrs: {
      "target": "blank"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.showThisDisclosure('Patriot_Cardholder_Agreement');
      }
    }
  }, [_vm._v("Patriot Bank's Debit Cardholder Agreement")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row items-start space-x-3 ml-10"
  }, [_c('span', {
    staticClass: "h-16 sm-md:w-48 check-img",
    class: {
      checked: _vm.formPolicyConsentTimestamps.extra_credit_notice
    },
    attrs: {
      "role": "presentation"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "leading-5"
  }, [_c('a', {
    attrs: {
      "target": "blank"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.showThisDisclosure('Standing_ACH_Authorization');
      }
    }
  }, [_vm._v("Standing ACH Authorization")])])]), _vm._v(" "), _vm.planAutopay ? _c('div', {
    staticClass: "flex flex-row items-start space-x-3 ml-10"
  }, [_c('span', {
    staticClass: "h-16 sm-md:w-48 check-img",
    class: {
      checked: _vm.formPolicyConsentTimestamps.extra_credit_notice
    },
    attrs: {
      "role": "presentation"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "leading-5"
  }, [_c('a', {
    attrs: {
      "target": "blank"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.showThisDisclosure('Recurring_ACH_Authorization');
      }
    }
  }, [_vm._v("Recurring Membership ACH Authorization")])])]) : _vm._e(), _vm._v(" "), !_vm.planAutopay ? _c('div', {
    staticClass: "flex flex-row items-start space-x-3 ml-10"
  }, [_c('span', {
    staticClass: "h-16 sm-md:w-48 check-img",
    class: {
      checked: _vm.formPolicyConsentTimestamps.extra_credit_notice
    },
    attrs: {
      "role": "presentation"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "leading-5"
  }, [_c('a', {
    attrs: {
      "target": "blank"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.showThisDisclosure('One_Time_ACH_Authorization');
      }
    }
  }, [_vm._v("One-Time ACH Authorization")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row items-start space-x-3 ml-10"
  }, [_c('span', {
    staticClass: "h-16 sm-md:w-48 check-img",
    class: {
      checked: _vm.formPolicyConsentTimestamps.extra_credit_notice
    },
    attrs: {
      "role": "presentation"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "leading-5"
  }, [_c('a', {
    attrs: {
      "target": "blank",
      "href": _vm.isInLeadLOCEligibleState ? '/legal/lead-loc' : '/legal/lead-loc-excluded-states'
    }
  }, [_vm._v("Lead Bank Overdraft Line of Credit Agreement\n\t\t\t\t\t\t\t\t\t\t\t\t\t"), (_vm$form = _vm.form) !== null && _vm$form !== void 0 && (_vm$form = _vm$form.address) !== null && _vm$form !== void 0 && _vm$form.state && !_vm.isInLeadLOCEligibleState ? _c('span', {
    staticClass: "text-xs"
  }, [_vm._v("(Effective June 20"), _c('sup', [_vm._v("th")]), _vm._v(", 2024)*")]) : _vm._e()])])])]), _vm._v(" "), _vm.formPaymentOptionEnabled ? _c('div', {
    staticClass: "flex flex-row items-center space-x-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formPaymentOptionAgreed,
      expression: "formPaymentOptionAgreed"
    }],
    attrs: {
      "id": "payment_option-input",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.formPaymentOptionAgreed) ? _vm._i(_vm.formPaymentOptionAgreed, null) > -1 : _vm.formPaymentOptionAgreed
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.formPaymentOptionAgreed,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.formPaymentOptionAgreed = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.formPaymentOptionAgreed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.formPaymentOptionAgreed = $$c;
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "payment_option-input"
    }
  }, [_vm.paymentOption === 'next_day_ach' ? [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tI agree to the next day payment option to make sure all of my payments are\n\t\t\t\t\t\t\t\t\t\t\t\ton time."), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        _vm.showPaymentOptionEducation = true;
      }
    }
  }, [_vm._v("Click here for other payment options")])] : [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tI understand the risk of 14 day payment option and would like to proceed\n\t\t\t\t\t\t\t\t\t\t\t\tanyway."), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.resetToNextDay.apply(null, arguments);
      }
    }
  }, [_vm._v("Click here to return to next day pay")])]], 2)]) : _vm._e(), _vm._v(" "), !_vm.growthbookDynamicValues.funnel_ecbsv_modal && (_vm.growthbookDynamicValues.funnel_ecbsv_enabled_public ||
  // if enabled for all
  _vm.growthbookDynamicValues.funnel_ecbsv_enabled_staff && (_vm$memberProfile2 = _vm.memberProfile) !== null && _vm$memberProfile2 !== void 0 && _vm$memberProfile2.form.email.includes('@extra.app')) // not to be used for sensitive features
  ? _c('div', {
    staticClass: "flex flex-row my-8"
  }, [_c('div', {
    staticClass: "color--dark--grey space-y-5"
  }, [_c('label', {
    staticClass: "text-lg mb-10",
    attrs: {
      "for": "ecbsv_authorization_language"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tAuthorization for the Social Security Administration to Disclose Your Social\n\t\t\t\t\t\t\t\t\t\t\t\tSecurity Number Verification\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "text-base opacity-75",
    attrs: {
      "id": "ecbsv_authorization_language"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tI authorize the Social Security Administration (SSA) to verify and disclose\n\t\t\t\t\t\t\t\t\t\t\t\tto Extra through SentiLink Verification Services Corp., their service\n\t\t\t\t\t\t\t\t\t\t\t\tprovider, for the purpose of debit card issuance, whether the name, Social\n\t\t\t\t\t\t\t\t\t\t\t\tSecurity Number (SSN) and date birth I have submitted matches information in\n\t\t\t\t\t\t\t\t\t\t\t\tSSA records. My consent is for for a one-time validation within the next 90\n\t\t\t\t\t\t\t\t\t\t\t\tdays.\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "space-x-5 flex flex-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formPolicies,
      expression: "formPolicies"
    }],
    staticClass: "mt-1 space-x-5",
    attrs: {
      "id": "ecbsv_authorization-input",
      "value": "ecbsv_authorization",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.formPolicies) ? _vm._i(_vm.formPolicies, "ecbsv_authorization") > -1 : _vm.formPolicies
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.formPolicies,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = "ecbsv_authorization",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.formPolicies = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.formPolicies = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.formPolicies = $$c;
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "text-base opacity-75",
    attrs: {
      "for": "ecbsv_authorization-input"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tI agree. By checking here, you are signing the consent for SSA to disclose\n\t\t\t\t\t\t\t\t\t\t\t\t\tyour SSN Verification to Extra and SentiLink Verification Services Corp.\n\t\t\t\t\t\t\t\t\t\t\t\t\tYou agree that your electronic signature has the same legal meaning,\n\t\t\t\t\t\t\t\t\t\t\t\t\tvalidity, and effect as your handwritten signature.\n\t\t\t\t\t\t\t\t\t\t\t\t")])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "mt-12 sm-md:mt-8 mb-4 text-md leading-5 color--dark--grey"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tYou will be charged for your Extra membership immediately upon approval. Future\n\t\t\t\t\t\t\t\tmembership payments will be automatically charged to your Plaid-connected account.\n\t\t\t\t\t\t\t\tIdentity documents may be required prior to approval or card activation.\n\t\t\t\t\t\t\t")]), _vm._v(" "), !_vm.isInLeadLOCEligibleState ? _c('div', {
    staticClass: "mt-6 mb-4 text-md leading-5 color--dark--grey"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t*Your Spend Power will become a line of credit with Lead Bank as of June\n\t\t\t\t\t\t\t\t20"), _c('sup', [_vm._v("th")]), _vm._v(", 2024. This does not change your fees nor will interest be charged.\n\t\t\t\t\t\t\t\tPlease read the Lead Bank Overdraft Line of Credit Agreement for full details.\n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button--filled mt-8 sm:w-full",
    attrs: {
      "disabled": !_vm.formFilled || _vm.formProcessing,
      "type": "submit"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.formProcessing ? 'Hold tight...' : 'Submit for review') + "\n\t\t\t\t\t\t\t")])], 1)], 1)])], 1) : _vm.currentStage === _vm._STAGE_enum.confirmInfo ? _c('confirm-info-section', {
    key: _vm._STAGE_enum.confirmInfo,
    attrs: {
      "initial-form": _vm.form
    },
    on: {
      "continue": _vm.fetchProfile
    }
  }) : _vm.currentStage === _vm._STAGE_enum.persona ? _c('persona-section', {
    key: _vm._STAGE_enum.persona,
    attrs: {
      "member-profile": _vm.memberProfile
    },
    on: {
      "loading": loading => _vm.stageLoading = loading,
      "complete": _vm.onPersonaComplete,
      "error": error => _vm.onSectionError(_vm._STAGE_enum.persona, error),
      "relinkPlaid": _vm.showPlaidRelinkErrorScreen
    }
  }) : _vm.currentStage === _vm._STAGE_enum.confirmation ? _c('confirmation-screen', {
    key: _vm._STAGE_enum.confirmation,
    attrs: {
      "title": _vm.alreadyHasSubscription ? 'Confirm your updated cardholder status.' : 'Ready to become a cardholder?',
      "policies": _vm.confirmationPolicyConsentTimestamps,
      "plans": _vm.plans,
      "plan": _vm.plan,
      "plan-header-text": _vm.alreadyHasSubscription ? 'Please re-confirm your current plan' : 'Plan type',
      "allow-plan-change": !_vm.alreadyHasSubscription,
      "allow-autopay-change": _vm.allowAutopayChange,
      "plan-autopay": _vm.planAutopay,
      "continue-button-action": _vm.confirmPlan,
      "continue-button-text": _vm.alreadyHasSubscription ? 'Agree' : 'Become a cardholder',
      "is-cau": _vm.alreadyHasSubscription,
      "current-plan-name": (_vm$memberProfile3 = _vm.memberProfile) === null || _vm$memberProfile3 === void 0 ? void 0 : _vm$memberProfile3.current_plan_name,
      "metadata": _vm.achPolicyMetadata,
      "member-profile": _vm.memberProfile,
      "plan-type": _vm.selectedPlan.title,
      "use-patriot": _vm.usePatriot
    },
    on: {
      "update:policies": function ($event) {
        _vm.confirmationPolicyConsentTimestamps = $event;
      },
      "update:plan": function ($event) {
        _vm.plan = $event;
      },
      "update:planAutopay": function ($event) {
        _vm.planAutopay = $event;
      },
      "update:plan-autopay": function ($event) {
        _vm.planAutopay = $event;
      },
      "setBalanceCheck": function ($event) {
        _vm.plaidInsufficient = $event;
      },
      "showThisDisclosure": _vm.showThisDisclosure,
      "relinkPlaid": _vm.showPlaidRelinkErrorScreen
    }
  }) : _vm.currentStage === _vm._STAGE_enum.mlaNotice ? _c('mla-notice-section', {
    key: _vm._STAGE_enum.mlaNotice,
    on: {
      "continue": function ($event) {
        _vm.mlaNoticeViewed = true;
      }
    }
  }) : _vm.currentStage === _vm._STAGE_enum.creditBand ? _c('section', {
    key: _vm._STAGE_enum.creditBand
  }, [_c('div', {
    staticClass: "section--container"
  }, [_c('member-survey', {
    attrs: {
      "initial-question-ids": _vm.memberProfile.credit_goals_pending_questions,
      "credit-band-variant": _vm.creditBandVariant,
      "credit-band-question": !_vm.creditBandAnswered,
      "member-profile": _vm.memberProfile
    },
    on: {
      "showDisclosure": _vm.showThisDisclosure,
      "complete": _vm.memberSurveyCompleteHandler
    }
  })], 1)]) : _vm.currentStage === _vm._STAGE_enum.backupPayment ? _c('backup-payment-stage', {
    key: _vm._STAGE_enum.backupPayment,
    on: {
      "continue": () => _vm.backupPaymentOnFile = true,
      "loading": loading => _vm.stageLoading = loading,
      "error": error => _vm.onSectionError(_vm._STAGE_enum.backupPayment, error)
    }
  }) : _vm.currentStage === _vm._STAGE_enum.survey ? _c('survey-screen', {
    key: _vm._STAGE_enum.survey,
    attrs: {
      "mid": _vm.memberProfile.id,
      "email": _vm.memberProfile.form && _vm.memberProfile.form.email || _vm.form.email,
      "address": _vm.memberProfile.form && _vm.memberProfile.form.address || _vm.form.address,
      "plan-price-usd": _vm.upfrontPrice,
      "continue-button-action": _vm.submitSurvey
    },
    on: {
      "loading": loading => _vm.stageLoading = loading
    }
  }) : _vm.currentStage === _vm._STAGE_enum.confirmed ? _c('section', {
    key: _vm._STAGE_enum.confirmed,
    staticClass: "dash--section"
  }, [_c('div', {
    staticClass: "section--container"
  }, [_c('div', {
    staticClass: "container section--content"
  }, [_c('div', {
    staticClass: "flex flex-col items-center w-full"
  }, [_c('confirmed-screen', {
    attrs: {
      "from-app": _vm.fromApp
    }
  }), _vm._v(" "), _vm.kycStatus !== 'PASSED' ? _c('div', {
    staticClass: "flex max-w-2xl px-10 py-6 mt-8 mb-4 card kyc-card fade-in-3 align-center sm-md:flex-col sm-md:px-8"
  }, [_c('img', {
    staticClass: "w-10 mr-8 sm-md:w-8 sm-md:mb-3",
    attrs: {
      "src": require("assets/images/info_blue.svg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-grow"
  }, [_c('p', {
    staticClass: "mb-2 text-2xl font-semibold leading-6"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\tBefore we can ship your card..."), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "text-base leading-6"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\tWe'll just need to verify a few more things."), _c('br'), _vm._v("Not to worry, you'll be\n\t\t\t\t\t\t\t\t\t\treceiving an email shortly with next steps.\n\t\t\t\t\t\t\t\t\t")])])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "my-6 space-y-2 text-lg leading-8 text-center sm-md:text-md fade-in-3 sm-md:my-4 sm-md:text-base sm-md:leading-6"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tIf you have any questions or wish to cancel, reach out to Member Concierge at\n\t\t\t\t\t\t\t\t"), _c('a', {
    attrs: {
      "href": "mailto:hey@extra.app"
    }
  }, [_vm._v("hey@extra.app")]), _vm._v(".\n\t\t\t\t\t\t\t")]), _vm._v(" "), !_vm.fromApp ? _c('div', {
    staticClass: "mt-5 mb-12 sm-md:mt-4 fade-in-4"
  }, [_c('download-badges')], 1) : _vm._e(), _vm._v(" "), _c('task-box', {
    staticClass: "mt-4 mb-12 fade-in-4",
    attrs: {
      "align-center": true,
      "title": "Join our community",
      "subtitle": !_vm.memberProfile.follows_insta && 'We share exclusive updates here with our Members',
      "checked": _vm.memberProfile.follows_insta,
      "details-logo": require('~/assets/images/extra-finsta.png'),
      "details-title": "@extra.card",
      "details-link": "https://instagram.com/extra.card",
      "button-text": !_vm.memberProfile.follows_insta && `${_vm.memberProfile.insta_handle ? 'Update' : 'Add'} your IG handle`,
      "button-action": _vm.instagramPrompt
    }
  }), _vm._v(" "), _c('disclosure-footer', {
    staticClass: "fade-in-4"
  })], 1)])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('disclosure-modal', {
    attrs: {
      "show": _vm.showDisclosure,
      "disclosure": _vm.disclosureFile,
      "metadata": _vm.metadataForCurrentPolicy
    },
    on: {
      "close": _vm.viewedDisclosure
    }
  }), _vm._v(" "), _vm.currentStage === _vm._STAGE_enum.form ? _c('payment-option-education', {
    attrs: {
      "open": _vm.showPaymentOptionEducation,
      "mid": (_vm$memberProfile4 = _vm.memberProfile) === null || _vm$memberProfile4 === void 0 ? void 0 : _vm$memberProfile4.id,
      "form-filled": _vm.formFilled
    },
    on: {
      "update:open": function ($event) {
        _vm.showPaymentOptionEducation = $event;
      },
      "set-payment-option": _vm.setPaymentOption
    }
  }) : _vm._e(), _vm._v(" "), _vm.isDev ? _c('dev-menu', {
    attrs: {
      "parent": this
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };